import { Logger, REQUEST_METHODS } from '@futrli/shared-services';
import { toastError } from '@futrli/ui-components';

import { makeRequestWithResponse } from '../../core/api/shared';
import { downloadFile, viewFile } from '../../ui/virtualized-list/document-library/utils';

const handleError = (error: unknown): void => {
  Logger.error(error as string);
  toastError();
};

/**
 * Fetches the view URL for a PDF and opens it in a new browser tab.
 * Handles errors internally by logging and displaying a toast notification.
 *
 * @param downloadLink - The API endpoint to fetch the PDF view URL from.
 */
export const openPdfForViewing = async (downloadLink: string): Promise<void> => {
  try {
    const downloadURL: { view_url: string } = await makeRequestWithResponse({
      url: downloadLink,
      method: REQUEST_METHODS.GET
    });
    await viewFile(downloadURL.view_url);
  } catch (e) {
    handleError(e);
  }
};

/**
 * Fetches the download URL for a PDF and triggers a file download.
 * Handles errors internally by logging and displaying a toast notification.
 *
 * @param downloadLink - The API endpoint to fetch the PDF download URL from.
 * @param fileName - The filename to save the downloaded file as.
 */
export const downloadPdfFile = async (downloadLink: string, fileName: string): Promise<void> => {
  try {
    const downloadURL: { url: string } = await makeRequestWithResponse({
      url: downloadLink,
      method: REQUEST_METHODS.GET
    });
    await downloadFile(downloadURL.url, fileName);
  } catch (e) {
    handleError(e);
  }
};
